import { BaseModel } from './baseModel';
import { Deserializable } from './deserializable';


export class MonthlyActivatedDevices extends BaseModel implements Deserializable {
  month : string;
  year : number;
  activatedDevices : number;
  subTotalActivatedDevices: number;

  deserialize(input: any) {
    super.deserialize(input);
    Object.assign(this, input);

    return this;
  }
}
